import { Component, Input, OnInit } from '@angular/core';
import { EventResource } from 'src/app/interfaces/event-resource';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-event-preview-mobile',
  templateUrl: './event-preview-mobile.component.html',
  styleUrls: ['./event-preview-mobile.component.scss']
})
export class EventPreviewMobileComponent implements OnInit {
  /**
   * THe ID of the Event passedIn
   */
  @Input() eventID;
  /**
   * The Event as an Object
   */
  public event:EventResource;
  /**
   * 
   * @param eventService 
   */
  constructor(private eventService:EventService) { }

  /**
   * ngOnInit 
   * Get the Event passedin
   */
  ngOnInit(): void {
    this.eventService.getEvent(this.eventID).subscribe((event: EventResource) => {
      this.event = event;
    })
  }

}
